export default __webpack_public_path__ + "static/media/Across-logo-bullet.ae32b017.svg";